module.exports = __webpack_public_path__ + "media/images/v1/line-c990061ab28713569b162977c46e4695.png";